import { R as React } from './injectIntl-6b03af4d.js';
import { T as Tooltip } from './Tooltip-c701801b.js';

/** @jsx React.createElement */
function ApTooltipReact(props) {
    const { content, placement = 'bottom', disabled = false, hide = false, children, formattedContent, dontUseInternalOnlyDebugForceOpen = false, } = props;
    // force positioning the tooltip in debug mode to ensure that it renders and positions correctly.
    const debugPopperInstanceRef = React.useRef(null);
    React.useLayoutEffect(() => {
        let forceUpdateInterval;
        if (dontUseInternalOnlyDebugForceOpen) {
            forceUpdateInterval = window.setInterval(() => {
                var _a;
                (_a = debugPopperInstanceRef.current) === null || _a === void 0 ? void 0 : _a.forceUpdate();
            }, 100);
        }
        return () => {
            window.clearInterval(forceUpdateInterval);
        };
    }, [dontUseInternalOnlyDebugForceOpen]);
    const hasCustomContent = Boolean(formattedContent);
    const tooltipProps = hasCustomContent ? makeTooltipRenderInSameDOMTree : {};
    return (React.createElement(Tooltip, Object.assign({ title: (hide || disabled) ? '' : (formattedContent !== null && formattedContent !== void 0 ? formattedContent : content), placement: placement }, tooltipProps, (dontUseInternalOnlyDebugForceOpen && {
        open: true,
        PopperProps: Object.assign(Object.assign({}, (tooltipProps.PopperProps)), { popperRef: debugPopperInstanceRef }),
    })), children));
}
const makeTooltipRenderInSameDOMTree = {
    PopperProps: {
        // Disable rendering in a portal and render inline instead.
        disablePortal: true,
        popperOptions: { strategy: 'fixed' },
    },
};

export { ApTooltipReact as A };

//# sourceMappingURL=ap-tooltip.react-64a190bd.js.map